export enum MODULES {
  IDENTITIES = 'IDENTITIES',
  APPS = 'APPS',
  CONNECTIONS = 'CONNECTIONS',
  MODULES = 'MODULES',
  NOTICES = 'NOTICES',
  KNOWLEDGEBASE = 'KNOWLEDGEBASE',
  NOTIFICATIONS = 'NOTIFICATIONS',
  MESSAGES = 'MESSAGES',
  LOGS = 'LOGS',
  MAILBOX = 'MAILBOX',
  AUTHORIZATION_PERMISSIONS = 'AUTHORIZATION_PERMISSIONS',
  AUTHORIZATION_ROLES = 'AUTHORIZATION_ROLES',
  AUTHORIZATION_PRIVILEGES = 'AUTHORIZATION_PRIVILEGES',
  STORAGE_DRIVE = 'STORAGE_DRIVE',
  STORAGE_RECYCLE_BIN = 'STORAGE_TRASH',
  REFERENCES = 'REFERENCES',
  INTEGRATIONS = 'INTEGRATIONS',
  SETUP = 'SETUP',

  // Custom Modules
  ARTICLES_NEWS = 'ARTICLES_NEWS',
  ARTICLES_BLOG = 'ARTICLES_BLOG',
  ARTICLES_CASE_STUDIES = 'ARTICLES_CASE_STUDIES',
  ATTENDANCE = 'ATTENDANCE',
  ARTICLES_EVENTS = 'ARTICLES_EVENTS',
  VACANCIES = 'VACANCIES',
  CONSULTATIONS = 'CONSULTATIONS',
  EMPLOYEE = 'EMPLOYEE',
  HOLIDAY = 'HOLIDAY',
  PROPOSALS = 'PROPOSALS',
  SUBMISSIONS = 'SUBMISSIONS',
  SUBSCRIBERS = 'SUBSCRIBERS',
  SUPPORT_CUSTOMERS = 'SUPPORT_CUSTOMERS',
  SUPPORT_PROJECTS = 'SUPPORT_PROJECTS',
  SUPPORT_RELEASES = 'SUPPORT_RELEASES',
  SUPPORT_TICKETS = 'SUPPORT_TICKETS',
  ROOMS = 'ROOMS',
  INVENTORY = 'INVENTORY',
  BOOKINGS = 'BOOKINGS',
  WORKSTATIONS = 'WORKSTATIONS',
  PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT',
}

export enum MODULE_GROUPS {
  AUTHORIZATION = 'AUTHORIZATION',
  INTEGRATIONS = 'INTEGRATIONS',
  STORAGE = 'STORAGE',
  REFERENCES = 'REFERENCES',
}

export enum MODULE_STATUSES {
  ACTIVATE = 'activate',
  DEACTIVATE = 'deactivate',
  HIDDEN = 'hidden',
  DISABLE = 'disable',
}
